import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the click on a captured text',
  name: 'captured_text_clicked',
  params: [
    {
      description: 'The ID of the captured text',
      name: 'text_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The captured text',
      name: 'text',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
